import { SyndicateRole } from '../../types/deal.types';

const ROLES_PRIORITY = [
  SyndicateRole.seniorManager,
  SyndicateRole.coSenior,
  SyndicateRole.coManager,
  SyndicateRole.sellingGroup,
  SyndicateRole.member,
  SyndicateRole.nonManager
];

export function roleComparer(prev: SyndicateRole, next: SyndicateRole): number {
  return ROLES_PRIORITY.indexOf(prev) > ROLES_PRIORITY.indexOf(next)
    ? 1
    : ROLES_PRIORITY.indexOf(prev) === ROLES_PRIORITY.indexOf(next)
    ? 0
    : -1;
}
